import { AxiosError } from "axios";
import { UseQueryResult } from "react-query";

import { useApiQuery } from "@/api";
import {
  DYNAMIC_EVENTS_REQUEST,
  DynamicEventsResponse,
  FunnelEvents,
  useInsightsEventDefs,
} from "@/api/insights";
import { useEventDefs } from "@/api/useEventDefs";
import { useConversionModalData } from "@/InsightsPage/hooks/useConversionModalData";
import { ENDPOINTS } from "@/InsightsPage/constants";
import { LoadedEventDefinition } from "@/types/global";

export type ConversionEventsContext = {
  enriched: UseQueryResult<FunnelEvents[]>;
  library: UseQueryResult<LoadedEventDefinition[]>;
  saved: UseQueryResult<DynamicEventsResponse, AxiosError>;
  showRecommendationCards: boolean;
};

/**
 * Loads the wizard's event data once per open panel, so moving between steps
 * doesn't rerun the Snowflake-backed lookups.
 */
export function useConversionEventsContext(): ConversionEventsContext {
  const enriched = useInsightsEventDefs();
  const library = useEventDefs();
  const saved = useApiQuery([
    ENDPOINTS.GET_DYNAMIC_EVENTS,
    DYNAMIC_EVENTS_REQUEST,
  ]);
  const { showRecommendationCards } = useConversionModalData();
  return { enriched, library, saved, showRecommendationCards };
}
